// src/com/trans_plan_bind_store/TransPlanBindStoreGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_BIND_STORE Apollo Graphql
 * 운송요청 동적 배차내역
 * Project: NewTOP for cloud
 * 2025-02-24 10:55:32 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_BIND_STORE_LIST_PART = gql`
fragment TransPlanBindStoreListPart on TransPlanBindStore {
    bindGroupNo
    planId
    bindOrderNo
    storeId
    storeName
    hocha
    dptrReqTime
    timeArrival
    arrived
    regUser
    regDate
    planDate
    vehInfoSeq
    vehPlates
    dcCd
    useYn
    comId
    comName
}
`;


// Backend uses getListForPlan
export const LIST_TRANS_PLAN_BIND_STORE = gql`
${TRANS_PLAN_BIND_STORE_LIST_PART}
query ListTransPlanBindStore($planId:String!) {
    transPlanBindStoreList(planId:$planId) {
        ...TransPlanBindStoreListPart
    }
}
`;

export const GET_TRANS_PLAN_BIND_STORE = gql`
${TRANS_PLAN_BIND_STORE_LIST_PART}
query GetTransPlanBindStore($planId:String!) {
    transPlanBindStoreItem(planId:$planId) {
        ...TransPlanBindStoreListPart
    }
}
`;

// transPlanBindStoreListAtDate(dcCd: String!, planDate: String!): [TransPlanBindStore]!
export const LIST_TRANS_PLAN_BIND_STORE_AT_DATE = gql`
${TRANS_PLAN_BIND_STORE_LIST_PART}
query ListTransPlanBindStoreAtDate($dcCd:String!, $planDate : String!) {
    transPlanBindStoreListAtDate(dcCd:$dcCd, planDate:$planDate) {
        ...TransPlanBindStoreListPart
    }
}
`;
// transPlanBindStoreListForPlan(planId: String!): [TransPlanBindStore]!
export const LIST_TRANS_PLAN_BIND_STORE_FOR_PLAN = gql`
${TRANS_PLAN_BIND_STORE_LIST_PART}
query ListTransPlanBindStoreForPlan($planId:String!) {
    transPlanBindStoreListForPlan(planId:$planId) {
        ...TransPlanBindStoreListPart
    }
}
`;
// transPlanBindStoreListNotBoundForSharing(dcCd: String!, planDate: String!): [TransPlanBindStore]!
/*
            t.plan_id AS planId,
            t.plan_date AS planDate,
            t.store_id AS storeId,
            s.store_name AS storeName,
            t.hocha,
            t.dptr_req_time AS dptrReqTime,
            t.veh_plates AS vehPlates
*/
export const LIST_TRANS_PLAN_BIND_STORE_NOT_BOUND_FOR_SHARING = gql`
query ListTransPlanBindStoreNotBoundForSharing($dcCd:String!, $planDate : String!) {
    transPlanBindStoreListNotBoundForSharing(dcCd:$dcCd, planDate:$planDate) {
        planId
        planDate
        storeId
        storeName
        hocha
        dptrReqTime
        vehPlates
        comId
        comName
    }
}
`;

export const LIST_TRANS_PLAN_BIND_STORE_GROUP_AND_SOLO = gql`
${TRANS_PLAN_BIND_STORE_LIST_PART}
query ListTransPlanBindStoreGroupAndSolo($dcCd:String!, $planDate : String!) {
    transPlanBindStoreListAtDate(dcCd:$dcCd, planDate:$planDate) {
        ...TransPlanBindStoreListPart
    }
    transPlanBindStoreListNotBoundForSharing(dcCd:$dcCd, planDate:$planDate) {
        planId
        planDate
        storeId
        storeName
        hocha
        dptrReqTime
        vehPlates
        comId
        comName
    }
}
`;

// 기존 그룹에 새로운 plan 추가. {bindGroupNo!, planId!, planIdAnchor, front}
export const ADD_TRANS_PLAN_BIND_STORE = gql`
mutation AddTransPlanBindStore($transPlanBindStore:InputTransPlanBindStoreAdd!) {
	transPlanBindStoreAdd(transPlanBindStore: $transPlanBindStore) {
		ok
		message
	}
}
`;

// 순서 변경. bindOrderNo를 변경한다. {bindGroupNo!, planId!, planIdAnchor!, front}
export const EDIT_TRANS_PLAN_BIND_STORE = gql`
mutation EditTransPlanBindStore($transPlanBindStore:InputTransPlanBindStoreEdit!) {
	transPlanBindStoreEdit(transPlanBindStore: $transPlanBindStore) {
		ok
		message
	}
}
`;

export const REMOVE_TRANS_PLAN_BIND_STORE = gql`
mutation RemoveTransPlanBindStore($transPlanBindStore:InputTransPlanBindStoreRemove!) {
	transPlanBindStoreRemove(transPlanBindStore: $transPlanBindStore) {
		ok
		message
	}
}
`;

/**
 * LIST_TRANS_PLAN_BIND_STORE_AT_DATE 결과 목록을
 * bindGroupNo를 key로 해서 묶인 객체들의 배열로 변환
 * @param {*} list 
 */
export function transPlanBindStoreListToTree(list) {
    const tree = [];
    const map = {};
    list.forEach((item) => {
        if(!map[item.bindGroupNo]) {
            map[item.bindGroupNo] = {
                bindGroupNo: item.bindGroupNo,
                planDate: item.planDate,
                dcCd: item.dcCd,
                comId: item.comId,
                comName: item.comName,
                vehPlates: item.vehPlates,
                stores: []
            };
            tree.push(map[item.bindGroupNo]);
        }
        map[item.bindGroupNo].stores.push(item);
    });
    Object.keys(map).forEach((key) => {
        for(let i=0; i<map[key].stores.length; i++) {
            if(map[key].stores[i].vehPlates) {
                map[key].vehPlates = map[key].stores[i].vehPlates;
                break;
            }
        }
    })
    return tree.sort((a, b) => {
        if(a.vehPlates && b.vehPlates) return a.vehPlates.localeCompare(b.vehPlates);
        if(a.vehPlates) return 1;
        if(b.vehPlates) return -1;
        return 0;
    });
};